import React, { useEffect, useState, useContext } from "react";
import {
  Box,
  Grid,
  Stack,
  Table,
  Button,
  TableRow,
  TableCell,
  TableBody,
  TableHead,
  TextField,
  Typography,
  TableContainer,
  InputAdornment
} from "@mui/material";
import "../Style/pagestyle.scss";
import { Link } from "react-router-dom";
import { useQuery } from "@apollo/client";
import CreateIcon from "../Assets/create-icon.svg";
import SearchIcon from "@mui/icons-material/Search";
import { AuthContext } from "../Context/AuthContext";
import { currencyFormat } from "../Function/DynamicFn";
import EmptyData from "../Components/Include/EmptyData";
import { GET_ITEM_PAGINATION } from "../Schema/ListItem";
import { translateLauguage } from "../Function/Translate";
import LoadingPage from "../Components/Include/LoadingPage";
import ListItemAction from "../Components/ListItem/ListItemAction";
import CreateListItem from "../Components/ListItem/CreateListItem";
import FooterPagination from "../Components/Include/FooterPagination";
 
export default function SetUpListItem() {
  // Change Language
  const { language } = useContext(AuthContext);
  const { t } = translateLauguage(language);
  const [loading, setLoading] = useState(false);

  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [keyword, setKeyword] = useState("");
  const [tableData, setTableData] = useState([]);
  const [paginationData, setPaginationData] = useState();

  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const { refetch } = useQuery(GET_ITEM_PAGINATION, {
    variables: {
      page: page,
      limit: limit,
      keyword: keyword,
      pagination: true,
    },
    onCompleted: ({ getItemPagination }) => {
      setLoading(false);
      setTableData(getItemPagination?.data);
      setPaginationData(getItemPagination?.paginator)
    },
    onError: (err) => {
      console.log("Error::", err?.message);
    },
  });

  const handleLimit = (e) => {
    setLimit(e.target.value);
    setPage(1);
  };

  const handleSearch = (e) => {
    setPage(1);
    setKeyword(e.target.value);
  };

  useEffect(() => {
    refetch();
  }, [page, limit, keyword]);

  // ======================= Resize width Screen ======================
  const [width, setWidth] = useState(window.innerWidth);
  const updateDimensions = () => {
    setWidth(window.innerWidth - 50);
  };
  useEffect(() => {
    window.addEventListener("resize", updateDimensions);
    return () => window.removeEventListener("resize", updateDimensions);
  }, []);

  return (
    <div className="page-container">
      <Stack direction="row" spacing={2} className="page-header">
        <Stack direction="column" justifyContent="center">
          <Box className="slash" />
        </Stack>

        <Stack direction="column" justifyContent="center">
          <Link className="page-link-title" to="/setting">
            <Typography className="page-title">{t("page_setting")}</Typography>
          </Link>
        </Stack>
        <Stack direction="column" justifyContent="center">
          <Typography className="slash-title">/</Typography>
        </Stack>
        <Stack direction="column" justifyContent="center">
          <Typography className="page-title">List Item</Typography>
        </Stack>

        <Box sx={{ flexGrow: 1 }} />

        <Stack direction="row" spacing={0.6}>
          <Stack direction="column" justifyContent="center">
            <Link className="page-link-title" to="/">
              {t("page_dashboard")}
            </Link>
          </Stack>
          <Stack direction="column" justifyContent="center">
            <Typography className="breadcrumbs-title">/</Typography>
          </Stack>
          <Stack direction="column" justifyContent="center">
            <Typography className="breadcrumbs-title">List Item</Typography>
          </Stack>
        </Stack>
      </Stack> 

      <Box sx={{ marginTop: "30px" }}>
        <Grid container spacing={3}>
          <Grid item xs={6} md={6} lg={3} xl={2.4}>
            <Typography className="search-head-title">
              Search
            </Typography>
            <TextField
              placeholder={"search"}
              size="small"
              className="search-field"
              onChange={handleSearch}
              InputProps={{
                startAdornment: (
                  <InputAdornment
                    position="start"
                    sx={{ mr: 1, color: "#0f81c2" }}
                  >
                    <SearchIcon />
                  </InputAdornment>
                ),
              }}
            />
          </Grid>

          <Grid item xs={6} md={6} lg={9} xl={9.6}>
            <Stack direction="row" justifyContent="right">
              <Button
                onClick={handleOpen}
                className="btn-create"
                startIcon={
                  <img src={CreateIcon} alt="CreateIcon" className="icon-add" />
                }
              >
                {t("create")}
              </Button>
              <CreateListItem
                open={open}
                handleClose={handleClose}
                setRefetch={refetch}
              />
            </Stack>
          </Grid>
        </Grid>
      </Box>

      <Box className="body-container">
        <TableContainer sx={{ maxWidth: `${width}px` }}>
          <Table className="table" aria-label="simple table">
            <TableHead className="header-row ">
              <TableCell className="header-title-start">{t("no")}</TableCell>
              <TableCell className="header-title">Item Name/Number</TableCell>
              <TableCell className="header-title">Income Type</TableCell>
              <TableCell className="header-title">Description</TableCell>
              <TableCell className="header-title-end"></TableCell>
            </TableHead>
            {loading ? (
              <TableBody className="body">
                <TableRow className="body-row">
                  <TableCell
                    colSpan={10}
                    className="body-cell"
                    sx={{ bgcolor: "#fff" }}
                  >
                    <LoadingPage />
                  </TableCell>
                </TableRow>
              </TableBody>
            ) : (
              <>
                {tableData?.length === 0 ? (
                  <TableBody className="body">
                    <TableRow className="body-row">
                      <TableCell colSpan={10} className="body-cell">
                        <EmptyData />
                      </TableCell>
                    </TableRow>
                  </TableBody>
                ) : (
                  <>
                    <TableBody className="body">
                      {tableData?.map((row, index) => {
                        return (
                          <TableRow className="body-row" key={index}>
                            <TableCell className="body-cell-start">
                              {index + 1}
                            </TableCell>
                            <TableCell className="body-cell">
                              {row?.itemName}
                            </TableCell>
                            <TableCell className="body-cell">
                              {row?.incomeType}
                            </TableCell>
                            <TableCell className="body-cell">
                              {row?.itemDescription}
                            </TableCell>
                            <TableCell className="body-cell-end" align="right">
                              <ListItemAction
                                editData={row}
                                setRefetch={refetch}
                              />
                            </TableCell>
                          </TableRow>
                        );
                      })}
                    </TableBody>
                  </>
                )}
              </>
            )}
          </Table>
        </TableContainer>

        {/* ==================== Pagination  ============================= */}
        <FooterPagination
          totalPages={paginationData?.totalPages}
          totalDocs={paginationData?.totalDocs}
          limit={limit}
          page={page}
          setPage={setPage}
          handleLimit={handleLimit}
          setLoading={setLoading}
        />
      </Box>
    </div>
  );
}
